import React, { useEffect, useState } from "react";
import { Exercise } from "../../../models/Exercise";
import useEvents from "../hooks/useEvents";
import "./style.scss";
import "../../../../style/feature.scss";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import { HiOutlineClock, HiOutlineTicket } from "react-icons/hi";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useTranslation } from "react-i18next";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import useGetLowestPrice from "../../../../utils/hooks/useGetLowestPrice";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import { replaceVariablesInString } from "../../CustomOffer/OfferModules/replaceVariablesInString";
import EAIconButton from "../../shared/Buttons/EAIconButton";

interface IProps {
  item: Exercise;
  saleStep?: SaleStep;
  highlightedFeatures?: string[];
}

const EventSingle: React.FC<IProps> = ({ item, saleStep, highlightedFeatures }) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const { getTicketsForEvent, tickets } = useEvents();
  const [open, setOpen] = useState(false);
  const { formatTicketAccess, ticketAccess } = useEvents();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket, setItemQuantity } = usePreBasket();
  const { getBasket } = useBasketManager();
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const showTicketLimits = useSelector((state: State) => state.config.configuration.showTicketsPoolForEventsSale);

  const handleDeleteBasket = () => {
    clearBasket();
    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    formatTicketAccess(item);
    getTicketsForEvent(item.exerciseGroup.objectDb, item.exerciseGroup.objectId);
    //eslint-disable-next-line
  }, [item.objectId]);

  const getButtonTitle = () => {
    if (open) {
      return `${t("schowaj_bilety")}`;
    }
    return `${t("pokaz_bilety")}`;
  };

  const lowestPrice = useGetLowestPrice(tickets, isDesktop, !saleStep?.mainPrice);

  return (
    <>
      <EAProductBanner
        title={item.name}
        pictureUrl={item.eventMessage}
        description={item.description}
        mainPrice={saleStep?.mainPrice ? saleStep.mainPrice.replace("{{price}}", lowestPrice) : lowestPrice}
        crossedPrice={saleStep?.crossedPrice ? saleStep.crossedPrice.replace("{{price}}", lowestPrice) : ""}
        buttonTitle={getButtonTitle()}
        buttonStartIcon={<HiOutlineTicket />}
        buttonVariant={open ? "outlined" : "filled"}
        expanded={open}
        onClick={() => setOpen(!open)}
        highlightBanner={saleStep?.highlightBanner}
        bannerLabel={replaceVariablesInString(saleStep?.bannerLabel ? saleStep.bannerLabel : "", item)}
        additionalPriceInfo={saleStep?.priceLabel}
        highlightedFeatures={highlightedFeatures}
        loginRequired={saleStep?.loginRequired}
      >
        <div className="single-event-tickets">
          {showTicketLimits && (
            <div className="head-title flex-start-center">
              <span>
                {t("pozostalo")}:{" "}
                <b className="flex-start">
                  {item.capacity - (item.reserved + item.prereservation)} {t("biletow")}
                  {item.capacity - (item.reserved + item.prereservation) === 0 && item.prereservation > 1 && (
                    <EAIconButton
                    compact
                      title="Bilety na to wydarzenie są teraz w koszykach innych osób. Jeśli ktoś nie dokończy zakupu, miejsca wrócą do sprzedaży – zajrzyj za 20–30 minut"
                      icon={<HiOutlineClock />}
                      variant="filled"
                      color="primary"
                    />
                  )}
                </b>
              </span>
            </div>
          )}
          {item.capacity - item.reserved > 0 ? (
            <>
              {tickets.map((itemTicket, index) => (
                <div className={"ticket-block"} key={index}>
                  <TicketLineSummary
                    item={itemTicket}
                    exercise={ticketAccess}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                    qntState={qntState}
                    allowManualInput={true}
                    setItemQuantity={setItemQuantity}
                    ticketLimit={item.capacity - item.reserved}
                  />
                </div>
              ))}
            </>
          ) : (
            <div className="alert alert-red">{t("wszystkie_bilety_zostaly_sprzedane")}</div>
          )}

          <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
        </div>
      </EAProductBanner>
    </>
  );
};

export default EventSingle;
